import i18n from "i18n-js";
import { Logger } from "@devforce/trailhead-client-logger";
export const PACKAGE_NAME = "@devforce/trailhead-client-locale";
export const SUPPORTED_LOCALES = ["de", "en", "es-MX", "fr", "ja", "pt-BR"];
export const DEFAULT_LOCALE = "en";
export const DEFAULT_FALLBACKS = false;
export const logger = new Logger({
    prefix: `[${PACKAGE_NAME}]: `,
});
i18n.fallbacks = DEFAULT_FALLBACKS;
i18n.missingTranslation = (key) => {
    let message = `missing "${key}" translation for locale "${i18n.locale}"`;
    logger.warn(message);
    return `[${message}]`;
};
i18n.missingPlaceholder = (placeholder, label) => {
    logger.warn(`missing "${placeholder}" placeholder in "${label}"`);
    return `[missing ${placeholder} value]`;
};
let guid = 0;
export class I18n {
    constructor(scope) {
        this.id = guid++;
        if (scope)
            this.addScope(scope);
    }
    t(scope, key, options) {
        return i18n.t(`${scope}_${this.id}.${key}`, options);
    }
    addScope(scope) {
        for (const [scopeName, locales] of Object.entries(scope)) {
            for (const [locale, labels] of Object.entries(locales)) {
                const localeKey = toLocaleKey(locale);
                i18n.translations[localeKey] = {
                    ...i18n.translations[localeKey],
                    [`${scopeName}_${this.id}`]: labels,
                };
            }
        }
    }
}
// "esMX" => "es-MX"
export function toLocaleKey(value) {
    return value.replace(/([a-z]{2,3})(?:[_-])?([A-Z]{2})/g, (_, lang, country) => `${lang}-${country.toUpperCase()}`);
}
export function configure(configHandler) {
    state.configureHandlers.push(configHandler);
    for (let i18n of state.i18n) {
        configHandler(i18n);
    }
}
export function setLocale(locale) {
    configure((i18n) => {
        i18n.locale = locale;
    });
    for (let handler of state.changeHandlers) {
        handler(locale);
    }
}
export function getLocale() {
    return i18n.currentLocale();
}
export function registerLocaleChangeHandler(handler) {
    state.changeHandlers.push(handler);
    return () => {
        state.changeHandlers = state.changeHandlers.filter((h) => h !== handler);
    };
}
let state = {
    configureHandlers: [],
    changeHandlers: [],
    i18n: [i18n],
};
export function initializeState(currentState, existingState) {
    let [i18n] = currentState.i18n;
    if (existingState) {
        existingState.i18n = [...existingState.i18n, i18n];
        // Run configurations that happened before this module was loaded
        for (let configHandler of existingState.configureHandlers) {
            configHandler(i18n);
        }
        return existingState;
    }
    return currentState;
}
// This module may be executed multiple times from different sources
if (typeof window !== "undefined") {
    // @ts-ignore
    window[PACKAGE_NAME] = initializeState(state, window[PACKAGE_NAME]);
}
